import { Button } from "@core/button";
import { Text } from "@core/text";
import { useTranslation } from "react-i18next";

export default function DeleteConfirmPopUp({
  title,
  showDeletePopup,
  setShowDeletePopup,
  handleDelete,
}: {
  title: string;
  showDeletePopup: number | undefined;
  setShowDeletePopup: (showDeletePopup: number | undefined) => void;
  handleDelete: (id: number) => void;
}) {
  const { t } = useTranslation();
  console.log(showDeletePopup);
  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-lg p-6 text-center max-w-[550px]">
        <Text variant={"h3"}>{title}</Text>
        <div className="flex justify-center mt-4 space-x-4">
          <Button
            variant="solid"
            rounded="lg"
            size="md"
            bgColor="bg-gray-100 hover:bg-gray-200 dark:bg-gray-700 dark:hover:bg-gray-600"
            textColor="text-gray-800 dark:text-gray-100"
            onClick={() => setShowDeletePopup(undefined)}
          >
            {t("common.cancel")}
          </Button>

          <Button
            variant="ghost"
            rounded="lg"
            size="md"
            data-testid="delete-confirm-button"
            bgColor="bg-red-500 hover:bg-red-600"
            textColor="text-white"
            onClick={() => {
              handleDelete(showDeletePopup!);
              setShowDeletePopup(undefined);
            }}
          >
            {t("common.delete")}
          </Button>
        </div>
      </div>
    </div>
  );
}
